/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './BlogListItem.css';

function BlogListItem({ post, categories, inset }) {
  const fixSrcPath = (src = '') => {
    return src.replace('../', '');
  };

  if (inset) {
    return (
      <>
        <div className="inset" />
        <style jsx>{Styles}</style>
      </>
    );
  }

  if (!post) return null;
  return (
    <>
      <a
        href={`blog/${post.slug}${process.env.NODE_ENV === 'production' ? '.html' : ''}`}
        id={post.seo?.relatedLinkId}
        className="blog-list-card"
      >
        <picture>
          <source type="image/webp" srcSet={fixSrcPath(post.thumbnailSrcWebp)} />
          <source type="image/png" srcSet={fixSrcPath(post.thumbnailSrc)} />
          <img
            src={fixSrcPath(post.thumbnailSrc)}
            alt={post.thumbnailAlt}
            className="blog-list-img"
          />
        </picture>
        <div className="blog-list-card-conteudos">
          <h2
            className="title"
            dangerouslySetInnerHTML={{
              __html: post.thumbnailText,
            }}
          />
          <u className="saibamais">Saiba mais</u>
        </div>
      </a>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BlogListItem;
